import { Injectable } from '@angular/core';

import { TellentAnalytics } from '@core/tellent-util';

@Injectable({ providedIn: 'root' })
export class SecurityAnalytics extends TellentAnalytics {
  public readonly namespace = '2FA';

  public trackActivateTwoFactorAuth(kind: 'sms' | 'totp') {
    this.track('ActivateTwoFactorAuth', {
      kind,
    });
  }

  public trackDeactivateTwoFactorAuth(kind: 'sms' | 'totp') {
    this.track('DeactivateTwoFactorAuth', {
      kind,
    });
  }
}
